import { EventCategory, GetTimeFromTimestamp, MaterialList } from '@dave/types';
import { MaterialListEntity, MaterialListStatusEnum } from './material-list.entity';


export class EventCategoriesEntity {
    constructor(
        public Id: number = null,
        public Name: string = null,
        public PartnerId: number = null,
    ) {
    }

    public static EntityName = 'EventCategories';
    public Clone(override: Partial<EventCategoriesEntity> = {}): EventCategoriesEntity {
        const attr = { ...this, ...override };
        return Object.assign(new EventCategoriesEntity(), attr);
    }
}

export function EventCategoriesEntityFromBackend(res: EventCategory): EventCategoriesEntity {

    return new EventCategoriesEntity(
        res.Id && +res.Id,
        res.Name,
        res.PartnerId && +res.PartnerId,

    );
}

